import React from 'react'
import { Stack, Typography, Paper, Skeleton } from '@mui/material'

const Competitions: React.FC = () => {
  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="h4" component="h1">
          Competitions
        </Typography>
        <Typography color="text.secondary">
          Configure prizes, rules, and draw schedules while tracking entrant histories across rounds.
        </Typography>
      </Stack>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Skeleton variant="text" width="40%" sx={{ mb: 1.5 }} />
        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2, mb: 1.5 }} />
        <Skeleton variant="text" width="55%" />
      </Paper>
    </Stack>
  )
}

export default Competitions
